import { useSelector } from "react-redux";
import VisaVerifiedGrey from "../../../../assets/images/verifyTrades/VisaVerifiedGrey.svg";
import threeDSecureIcon from "../../../../assets/images/verifyTrades/3dSecureIcon.svg";
import MasterCardSecureCod from "../../../../assets/images/verifyTrades/MasterCardSecureCod.svg";
import stripeIcon from "../../../../assets/images/verifyTrades/stripeIcon.svg";
import moment from "moment";

const PaymentLogos = () => (
  <div className="verifiedPaymentMethodsPartners">
    <img src={threeDSecureIcon} alt="Payment Methods" />
    <img src={MasterCardSecureCod} alt="Payment Methods" />
    <img src={VisaVerifiedGrey} alt="Payment Methods" />
    <img src={stripeIcon} alt="Payment Methods" />
  </div>
);

// variant="leader" — blockchain description + billing date (VerifiedPaymentSubscriptionPlan)
// variant="member" — payment logos only in my-grid-sharing-icons layout (Subscribe.js)
const SubscriptionFooter = ({ variant = "leader" }) => {
  const user = useSelector((state) => state?.user?.user);
  const subscription = user?.verifiedmyTrade?.subscription;
  const memberCommunity = user?.memberCommunities?.[0];

  const getNextBillingDate = () => {
    if (memberCommunity?.subscriptionExpiry) {
      return moment(memberCommunity.subscriptionExpiry).format("DD-MM-YYYY");
    }
    return moment(new Date()).add(1, "months").format("DD-MM-YYYY");
  };

  if (variant === "member") {
    return (
      <div className="bottomDescrption">
        <p>
          7d Trial. Cancel or upgrade subscription anytime. Auto-renews.{" "}
          {memberCommunity?.subscriptionExpiry ? (
            <span className="fw-medium">Next billing date: {getNextBillingDate()}</span>
          ) : null}
        </p>

        <div className="paymentMethods">
          <p>Safe and Secure Payments Checkout</p>
            <PaymentLogos />
        </div>
      </div>
    );
  }

  return (
    <div className="bottomDescrption">
      <p>
        Your performance is auto-tracked on the blockchain with a shareable
        verification link. We suggest 3+ months of tracking as API limits only
        allow access to 7 days of data prior to signup. Cancel or upgrade
        anytime.
        {subscription?.active ? (
          <span>
            {" Next billing: "}
            {new Date(subscription.currentPeriodEnd).toLocaleDateString("en-US")}
          </span>
        ) : null}
      </p>
      <div className="paymentMethods">
        <p>Safe and Secure Payments Checkout</p>
        <PaymentLogos />
      </div>
    </div>
  );
};

export default SubscriptionFooter;
